module.exports = __webpack_public_path__ + "img/bg-ho-facil.0fef2844.jpg";